import type {Validator} from '@github-ui/safe-indexed-db-storage'

export function createServerPersistedQueryValidator(queryHash: string): Validator {
  return {
    // The server-persisted query hash is validated against the cache entry after
    // it is read. This only checks the minimum shape needed before that comparison.
    Check(value: unknown) {
      return typeof value === 'object' && value !== null
    },
    Code() {
      return `server-persisted-query:${queryHash}`
    },
    Errors() {
      return []
    },
  }
}
